import { useTheme } from '@repo/theme';
import ScreenNotFound from 'app/+not-found';
import { getNavigationThemes } from 'component/navigation/theme';
import { LoadingSpinnerContainer } from 'component/progress/loading-spinner';
import { loadThemeFontsAsync } from 'config/theme/fonts';
import { type RoutePath, Stack, useLocalSearchParams } from 'expo-router';
import { ThemeProvider } from 'expo-router/react-navigation';
import { useEffect, useMemo } from 'react';
import { fireAndForget } from 'util/hooks';
import { getDeploymentConfig } from 'util/util';

export function SuspenseFallback() {
    return <LoadingSpinnerContainer />;
}

export default function SiloLayout() {
    const { siloKey } = useLocalSearchParams<Extract<RoutePath, `/[siloKey]/${string}`>>();
    const tokens = useTheme();
    const { transparentNavigationTheme } = useMemo(() => getNavigationThemes(tokens), [tokens]);

    useEffect(() => {
        fireAndForget(loadThemeFontsAsync());
    }, [siloKey]);

    if (!isInStaticConfig(siloKey)) {
        return <ScreenNotFound />;
    }

    return (
        <ThemeProvider value={transparentNavigationTheme}>
            <Stack screenOptions={{ headerShown: false }} />
        </ThemeProvider>
    );
}

function isInStaticConfig(siloKey: string) {
    const staticSilos = getDeploymentConfig().allowedSilos;
    if (!staticSilos) {
        // If no static silos are defined, all silos are allowed
        return true;
    }

    return staticSilos.includes(siloKey);
}
